<template>
  <div class="social">
    <nav>
      <a href="#" :title="service" v-for="(attributes, service) in services" :class="linkClassList(service)" @click.prevent="toggleService(service)">{{ service }}</a>
    </nav>
    <section>
      <article v-for="(attributes, service) in services" v-if="attributes.value != null">
        <i class="ss-icon ss-social-regular" :title="service">{{ service }}</i>
        <input class="cm-field" type="text" :name="serviceName(service)" :placeholder="attributes.placeholder" v-model="attributes.value">
      </article>
    </section>
  </div>
</template>

<script>
  import FormOptions from './mixins/form-options'

  export default {
    mixins: [FormOptions],

    props: {
      data: {
        type: Object,
        default: {
          twitter: {
            value: null,
            placeholder: 'https://twitter.com/example'
          },
          facebook: {
            value: null,
            placeholder: 'https://facebook.com/example'
          },
          instagram: {
            value: null,
            placeholder: 'https://instagram.com/example'
          }
        }
      }
    },

    data () {
      return {
        services: this.data
      }
    },

    mounted() {
      // show at least one service if all are blank
      var firstService
      for (var service in this.services) {
        if (!firstService) firstService = service
        if (this.services[firstService].value !== null) return
      }
      this.services[firstService].value = ''
    },

    methods: {
      linkClassList (service) {
        let list = ['link', 'ss-icon', 'ss-social-regular']

        if (this.services[service].value !== null) {
          list.push('link--active')
        }

        return list
      },

      serviceName (service) {
        return `${this.model}[${service}_username]`;
      },

      toggleService (service) {
        this.services[service].value = (this.services[service].value == null) ? "" : null;
      }
    }
  }
</script>

<style lang="scss" scoped>
  nav {
    margin-top: $gutter / 4;
    margin-bottom: $gutter / 2;
  }

  .link {
    color: var(--fg-2);
    display: inline-block;

    &--active {
      color: var(--fg);
    }

    & + .link {
      margin-left: 5px;
    }
  }

  article {
    display: flex;
    flex-direction: row;

    i {
      flex: 30px 0 0;
      margin-bottom: $gutter / 2;
      align-self: center;
    }

    input {
      flex: 1;
    }
  }

  .cm-field {
    margin-bottom: $gutter / 2;
  }
  .ss-icon {
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// app/javascript/components/social-links.vue?702e94c8